import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import { InfoRounded } from '@material-ui/icons';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      backgroundColor: theme.palette.secondary.whisper
    },
    content: {
      display: 'flex',
      flexDirection: 'row',
    },
    textContent: {
      marginLeft: theme.spacing(1)
    }
  }
})
const StatusCard = ({ booking }) => {
  const classes = useStyles()
  if (booking?.scheduled_status === 'UNMATCHED' && ((booking?.is_whitelabel && booking?.isConfirmed))) {
    return (
      <Card className={classes.root}>
        <CardContent className={classes.content}>
          <InfoRounded color="secondary" />
          <Typography variant="body1" className={classes.textContent}>
            Your booking will not be confirmed until you are matched with a provider. You will be notified once
            a provider accepts your request.
          </Typography>
        </CardContent>
      </Card>
    )
  }
  return (
    <></>
  )
}

export { StatusCard };
